import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { LoggerService } from 'src/app/services/logger.service';
import { Recept } from '../../models/recept';
import { PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-sale-print-factor',
  templateUrl: './sale-print-factor.component.html',
  styleUrls: ['./sale-print-factor.component.css'],
})
export class SalePrintFactorComponent implements OnChanges {
  @Input() recept?: Recept;
  @Input() modalIsOpen?: boolean;

  @ViewChild('modalContent') modalContent!: any;
  @ViewChild('printButton') printButton!: any;
  @ViewChild('printBox') printBox!: any;

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  constructor(
    private logger: LoggerService,
    private modalService: NgbModal,
    private printService: PrintService
  ) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['modalIsOpen'] &&
      changes['modalIsOpen'].currentValue !== undefined
    ) {
      if (changes['modalIsOpen'].currentValue == true) {
        if (this.recept != null) {
          this.recept.nonInsuredPrice=0;
          this.recept.drugList.forEach((element) => {
            element.totalPrice = element.totalPrice ?? 0;
            element.insurancePrice = element.insurancePrice ?? 0;
            element.shareCurrencyPrice = element.shareCurrencyPrice ?? 0;
            element.paidPrice =
            element.totalPrice -
            element.insurancePrice -
            element.shareCurrencyPrice;

            this.recept!.nonInsuredPrice!+=element.shareCurrencyPrice;
          });
          this.openModal();
        }
      } else if (changes['modalIsOpen'].currentValue == false) {
        this.modalService.dismissAll();
      }
    }
  }

  public printDiv() {
    this.printService.print('print-factor');
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }

            this.callParent('ClosePrintModal', null);
          },
          (reason) => {
            this.callParent('ClosePrintModal', null);
          }
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public callParent(action: string, data: any) {
    this.parentAction.next(new PCTableOutputModel(action, data));
  }
}
